import React from "react";

interface Props {
  color?: string;
  size?: number;
}
export default function SortIcon({ color = "#79808A", size = 11 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 7 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.146525 3.24042L3.14329 0.151021C3.22797 0.0637222 3.34024 0.0106439 3.45967 0.00143655C3.57911 -0.0077708 3.69779 0.0275043 3.79412 0.100848L3.85081 0.150334L6.85424 3.23973C6.94312 3.33172 6.99506 3.45488 6.99966 3.58462C7.00427 3.71435 6.96122 3.8411 6.8791 3.93954C6.79698 4.03798 6.68185 4.10085 6.55671 4.11561C6.43157 4.13036 6.30564 4.09591 6.20407 4.01913L6.14806 3.96964L3.99884 1.75861V10.4845C3.99884 10.6091 3.95507 10.7294 3.87563 10.8233C3.7962 10.9172 3.68647 10.9782 3.56673 10.9952L3.49938 11C3.37853 11 3.26176 10.9549 3.17068 10.873C3.0796 10.7911 3.02036 10.678 3.00392 10.5546L2.99926 10.4845L2.99859 1.75723L0.853373 3.96895C0.768693 4.05625 0.656428 4.10933 0.536991 4.11854C0.417555 4.12775 0.298878 4.09247 0.20254 4.01913L0.146525 3.96895C0.0618254 3.88168 0.0103271 3.76597 0.00139379 3.64287C-0.00753948 3.51976 0.0266856 3.39745 0.0978464 3.29815L0.146525 3.24042Z"
        fill={color}
      />
    </svg>
  );
}
